var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hero'),_c('Highlight1'),_c('Highlight2'),_c('Highlight3'),_c('BlockchainHighlight'),_c('Footer',{attrs:{"disclaimerContent":3}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }